
import Vue from "vue";
import { mapState } from "vuex";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { IRootState } from "@/store/types";
import { LOYALTY } from "@/store/loyalty";

export default Vue.extend({
  computed: {
    customerDetailsRouteName: () => LOYALTY_ROUTE_NAMES.ACCOUNT_OFFERS_DETAILS,
    ...mapState({
      customersList: (state: IRootState) =>
        state.loyalty.customerList.map(a => ({
          accountNumber: a.accountNumber,
          customerName: a.customerName,
          segment: a.segment
        }))
    })
  },
  methods: {
    onItemClick(item: any) {
      this.$router.push({
        name: this.customerDetailsRouteName,
        params: { id: item.id }
      });
    }
  }
});
